<section class="section-goldn" *ngIf="laureatsBase.length > 0">
  <div class="header-goldn">
    <h2 class="titre-goldn">Les Gold'n Gob</h2>
    <h3 class="annee">Lauréats {{ derniereAnnee }}</h3>
  </div>

  <div class="content-goldn">
    <div class="bloc-produits">
      <div class="flex-laureats" #listeRef (scroll)="gererScrollInfini($event)">
        <a *ngFor="let jeu of laureats" 
           [routerLink]="route.parse('product', [jeu.ident])" 
           class="jeu-item">
          <div class="img-wrapper">
            <img [src]="imageErrors[jeu.ident] ? 'assets/img/logo/logo.png' : jeu.img" 
                 (error)="onImageError(jeu.ident)" 
                 [alt]="jeu.nom">
          </div>
          <span class="nom-jeu">{{ jeu.nom }}</span>
        </a>
      </div>

      <div class="action-grid-bottom">
        <a [routerLink]="route.parse('products-list', ['banner', '67f6133b0bac8', 'gold-n-gob'])" class="btn-goldn gold">
          Voir tous nos Gold'n Gob
        </a>
      </div>
    </div>

    <div class="bloc-info-prix">
      <div class="card-info-goldn">
        <div class="trophee-wrapper">
          <img src="assets/img/goldngob/trophee_goldNgob_no_bg.png" alt="Trophée Gold'n Gob" class="img-trophee">
        </div>
        
        <div class="text-info">
          <h3 class="sous-titre">Notre prix ludique</h3>
          <p class="description">L'excellence ludique récompensée par les pros et le public.</p>
        </div>

        <div class="actions-goldn">
          <a routerLink="/goldn-gob" class="btn-goldn bordeaux">En savoir plus...</a>
        </div>
      </div>
    </div>
  </div>
</section>